import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable({ providedIn: 'root' })
export class ToastsAnalyticsService extends AnalyticsBase {
  private readonly router = inject(Router);

  public readonly namespace = `Toasts`;

  public readonly requireViewContext = false;

  public trackError(title: string): void {
    this.track('ShowError', { title, URL: this.router.url });
  }
}
